import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { catchError } from 'rxjs/operators/catchError';
import { concat } from 'rxjs/operators/concat';
import { of } from 'rxjs/observable/of';
import { types as actions } from '../../reducers/actions';
import { TagService } from '../../services';
import { bulkUploadFinishedAction, addInfoAction } from '../../reducers/actions';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';
  
export default function(action$, store) {
  return action$.pipe(
    ofType(actions.BULK_UPLOAD),
    switchMap(action=>
      TagService.bulkUpload(action.file, action.siteId, store).pipe(
          mergeMap(data => [bulkUploadFinishedAction(data),
            addInfoAction()]),
          catchError((error, source) => retryAuthentication(action$, 'epics/tags/bulkUpload')(error, source).pipe(
              concat(of(addInfoAction()))
            )
          ),
      )
    )
  );
}


// WEBPACK FOOTER //
// ./src/epics/tags/bulkUpload.js